/* eslint-disable */
import * as THREE from 'three'
import r1 from './r1.js'
import o2 from './f.js'
import a from './b.js'
import r from './rr.js'

var l = function (e) {
  function n() {
    !function (e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function")
    }(this, n);
    var e = new THREE.MeshBasicMaterial({
      map: a.default.get("/images/flare-p2.png"),
      transparent: !0
    })
      , t = function (e, t) {
        if (!e)
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t
      }(this, (n.__proto__ || Object.getPrototypeOf(n)).call(this, new THREE.PlaneGeometry(475, 480), e, {
        amplitude: 50,
        depth: 50
      }));
    return t.ratioAlpha = {
      x: 0,
      y: 0
    },
      t.alpha = 0,
      t
  }
  return function (e, t) {
    if ("function" != typeof t && null !== t)
      throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }),
      t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
  }(n, o2.default),
    r1(n, [{
      key: "parallax",
      value: function (e) {
        this.ratioAlpha.x = Math.pow(1 - Math.abs(e.x), 2),
          this.ratioAlpha.y = Math.pow(Math.max(e.y + .5, 0), 2),
          this.alpha += .1 * (.5 * Math.max(.8, Math.min(this.ratioAlpha.x + this.ratioAlpha.y, 2)) - this.alpha),
          this.material.opacity = this.alpha,
          this.scale.x = this.scale.y = this.alpha,
          r(n.prototype.__proto__ || Object.getPrototypeOf(n.prototype), "parallax", this).call(this, e)
      }
    }, {
      key: "resize",
      value: function () { }
    }, {
      key: "dispose",
      value: function () {
        this.ratioAlpha = null,
          this.alpha = null,
          this.material = null,
          r(n.prototype.__proto__ || Object.getPrototypeOf(n.prototype), "dispose", this).call(this)
      }
    }]),
    n
}();
var t = { default: l }

export default t
